export default __webpack_public_path__ + "static/media/Rick-and-Morty-Doaly.0716bb12.jpg";